module.exports = __webpack_public_path__ + "img/Lacquers.cf946cc6.png";